import { BaseDimensionComponent } from "../models/components/commonComponents/BaseDimensionComponent";
import { EditorObject } from '../models/editor-object.model';
import { Position2D } from '../models/other/position2D.model';
import { getComponentFromSource } from "../generics-helper/getComponentFromSource.generic";
import { DockingBehaviourComponent } from "../models/components/commonComponents/DockingBehaviourComponent";
import { ComponentNames } from "../helper/componentNames";
import { componentsContain } from "../helper/componentsContain";
import { CollisionBehaviourComponent } from "../models/components/commonComponents/CollisionBehaviorComponent";

export class CollisionDetection {
    public static CheckBaseDimensionsCollision(bd1: BaseDimensionComponent, bd2: BaseDimensionComponent): boolean {
        //CD is wrong, has to consider the orientation for changing reference point and lenght/width

        /* 
    	
        X Axis: A is left, b is right
        Y Axis: A is top, b is bottom
        Z Axis: A is upper, B is lower	
    	
        AABBCD explanation graphics
    	
                             YLimitA																
                                v								
                         _ _ _ _ _ _ _ _ _ _ 					
                        |					|					
                        |					|					
              XLimitA >	|		TOP			| < XLimitB  		
                        |					|					
                        |_ _ _ _ _ _ _ _ _ _|					
                                 ^ 								
                              YLimitB	
    
    
    
                             ZLimitA
                                v
                         _ _ _ _ _ _ _ _ _ _ 
                        |					|
                        |					|
              XLimitA >	|		FRONT		| < XLimitB  
                        |					|
                        |_ _ _ _ _ _ _ _ _ _|
                                 ^ 
                              ZLimitB	
            	
        */

        var bd1XLimitA: number;
        var bd1XLimitB: number;
        var bd1YLimitA: number;
        var bd1YLimitB: number;
        var bd1ZLimitA: number;
        var bd1ZLimitB: number;

        var bd2XLimitA: number;
        var bd2XLimitB: number;
        var bd2YLimitA: number;
        var bd2YLimitB: number;
        var bd1ZLimitA: number;
        var bd1ZLimitB: number;

        var temp: number;

        bd1XLimitA = bd1.getCenter2D().x - bd1.box.width;
        bd1XLimitB = bd1.getCenter2D().x + bd1.box.width;
        bd1YLimitA = bd1.getCenter2D().y - bd1.box.length;
        bd1YLimitB = bd1.getCenter2D().y + bd1.box.length;
        //bd1ZLimitA = bd1.getCenter3D.Z() + bd1.Box.Height;
        //bd1ZLimitB = bd1.getCenter3D.Z() - bd1.Box.Height;

        bd2XLimitA = bd2.getCenter2D().x - bd2.box.width;
        bd2XLimitB = bd2.getCenter2D().x + bd2.box.width;
        bd2YLimitA = bd2.getCenter2D().y - bd2.box.length;
        bd2YLimitB = bd2.getCenter2D().y + bd2.box.length;
        //bd1ZLimitA = bd1.getCenter3D.Z() + bd2.Box.Height;
        //bd1ZLimitB = bd1.getCenter3D.Z() - bd2.Box.Height;		

        if (bd1.rotation == 1 || bd1.rotation == 3) {
            bd1YLimitA = bd1.getCenter2D().x - bd1.box.width;
            bd1YLimitB = bd1.getCenter2D().x + bd1.box.width;
            bd1XLimitA = bd1.getCenter2D().y - bd1.box.length;
            bd1XLimitB = bd1.getCenter2D().y + bd1.box.length;
        }

        if (bd2.rotation == 1 || bd2.rotation == 3) {
            bd2YLimitA = bd2.getCenter2D().x - bd2.box.width;
            bd2YLimitB = bd2.getCenter2D().x + bd2.box.width;
            bd2XLimitA = bd2.getCenter2D().y - bd2.box.length;
            bd2XLimitB = bd2.getCenter2D().y + bd2.box.length;
        }

        var collisionX = this.checkAxisCollision(bd1XLimitA, bd1XLimitB, bd2XLimitA, bd2XLimitB);
        var collisionY = this.checkAxisCollision(bd1YLimitA, bd1YLimitB, bd2YLimitA, bd2YLimitB);
        // var collisionZ = this.checkAxisCollision(bd1ZLimitA, bd1ZLimitB, bd2ZLimitA, bd2ZLimitB);//3d
        return collisionX && collisionY /*&& collisionZ*/;

    }

    static checkAxisCollision(b1LimitA, b1LimitB, b2LimitA, b2LimitB): boolean {
        return b1LimitB > b2LimitA && b1LimitA < b2LimitB;
    }


}
export function hasCollision(self: EditorObject, other: EditorObject): boolean {
    const collisionCorrection = 1;

    var r2 = self.getClientRect({});
    var r1 = other.getClientRect({});
    return !(
        r2.x >= r1.x + r1.width-collisionCorrection ||
        r2.x + r2.width-collisionCorrection <= r1.x ||
        r2.y >= r1.y + r1.height-collisionCorrection ||
        r2.y + r2.height-collisionCorrection <= r1.y
      );
}

export function colissionBehaviourIgnoresColissionWithCheck(self,other):boolean{
          // colission behaviour check
          var checkForColission = true;

          var cbcSelf = getComponentFromSource<CollisionBehaviourComponent>(ComponentNames.collisionBehaviorComponent, self.components);
          if (cbcSelf != null) {
            if (cbcSelf.ignoresCollisionWith != null) {
              innerloop:
              for (let index = 0; index < cbcSelf.ignoresCollisionWith.length; index++) {
                const element = cbcSelf.ignoresCollisionWith[index];
                if (componentsContain(other.components, element.componentType)) {
                  checkForColission = false;
                  break innerloop;
                }
              }
            }
          }
    
          var cbcOther = getComponentFromSource<CollisionBehaviourComponent>(ComponentNames.collisionBehaviorComponent, other.components);
          if (cbcOther != null) {
            if (cbcOther.ignoresCollisionWith != null) {
              innerloop:
              for (let index = 0; index < cbcOther.ignoresCollisionWith.length; index++) {
                const element = cbcOther.ignoresCollisionWith[index];
                if (componentsContain(self.components, element.componentType)) {
                  checkForColission = false;
                  break innerloop;
                }
              }
            }
          }
          return checkForColission;
}

export function rectHasCollision(selfClRect, otherClRect): boolean {
    var collisionX = CollisionDetection.checkAxisCollision(selfClRect.x, selfClRect.x + selfClRect.width, otherClRect.x, otherClRect.x + otherClRect.width);
    var collisionY = CollisionDetection.checkAxisCollision(selfClRect.y, selfClRect.y + selfClRect.height, otherClRect.y, otherClRect.y + otherClRect.height);

    return collisionX && collisionY;
}


export function isInSnapingRange(self: EditorObject, other: EditorObject, snappingrangeX: number, snappingrangeY: number): boolean {
    //clientrect gives height and width scaled right
    var selfClRect = self.getClientRect({});
    var otherClRect = other.getClientRect({});

    var marginLeft;
    var marginRight;
    var marginTop;
    var marginBottom;

    var scale = self.getStage().scaleX();
    var dbc = getComponentFromSource<DockingBehaviourComponent>(ComponentNames.dockingBehaviorComponent, self.components);
    if(dbc.offsetBox.backOffset){
        marginTop = dbc.offsetBox.backOffset * scale;
    }else{
        marginTop = 0;
    }
    if(dbc.offsetBox.frontOffset){
        marginBottom = dbc.offsetBox.backOffset * scale;
    }else{
        marginBottom = 0;
    }
    if(dbc.offsetBox.leftOffset){
        marginLeft = dbc.offsetBox.leftOffset * scale;
    }else{
        marginLeft = 0;
    }
    if(dbc.offsetBox.rightOffset){
        marginRight = dbc.offsetBox.rightOffset * scale;
    }else{
        marginRight = 0;
    }

    var selfXLimitA = selfClRect.x - snappingrangeX - marginLeft;
    var selfXLimitB = selfClRect.x + selfClRect.width + snappingrangeX + marginRight;
    var selfYLimitA = selfClRect.y - snappingrangeY - marginTop;
    var selfYLimitB = selfClRect.y + selfClRect.height + snappingrangeY + marginBottom;

    var collisionX = CollisionDetection.checkAxisCollision(selfXLimitA, selfXLimitB, otherClRect.x, otherClRect.x + otherClRect.width);
    var collisionY = CollisionDetection.checkAxisCollision(selfYLimitA, selfYLimitB, otherClRect.y, otherClRect.y + otherClRect.height);

    return collisionX && collisionY;
}

export function getCenter2D({ width, height, x, y }, rotation): Position2D {
    switch (rotation) {
        case 0:
            return new Position2D(x + (width / 2), y + (height / 2));
        case 1:
            return new Position2D(x - (height / 2), y + (width / 2));
        case 2:
            return new Position2D(x - (width / 2), y - (height / 2));
        case 3:
            return new Position2D(x + (height / 2), y - (width / 2));
    }

}